import {JobCareer} from "../domain/model/job_career";
import {Occupation} from "../domain/model/project";

// JobCareer[]より重複を排除したOccupation[]を抽出する
export const extractOccupationsFromJobCareers = (from: JobCareer[]): Occupation[] =>{
    const list: Occupation[] =[];

    // 値の抽出
    from.forEach((jobCareer: JobCareer) => {
        jobCareer.occupations.forEach((value: Occupation) => {
            list.push(value);
        })
    });

    // 重複値の削除
    return Array.from( new Set(list));
};



// WEBPACK FOOTER //
// ./src/util/helper_job_career.ts